module.exports = __webpack_public_path__ + "static/media/16d-01-HOME_vista.9d8f62b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16d/16d-01-HOME_vista.jpg
// module id = 197
// module chunks = 0